import Avatar from "@material-ui/core/Avatar";
import deepOrange from "@material-ui/core/colors/deepOrange";
import deepPurple from "@material-ui/core/colors/deepPurple";
import green from "@material-ui/core/colors/green";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import "./agile.css";

const styles = theme => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: "inline"
  },
  avatar: {
    margin: 10
  },
  orangeAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: deepOrange[500]
  },
  purpleAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: deepPurple[500]
  },
  green: {
    margin: 10,
    color: "#fff",
    backgroundColor: green[500]
  }
});

function AlignItemsList(props) {
  const { classes } = props;
  return (
    <div className="agile">
      <p className="headline">Electives</p>
      <List className="agile">
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar className={classes.orangeAvatar}>E</Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="ECONOMICS"
            secondary={
              <React.Fragment>
                {/* <Typography
                component="span"
                className={classes.inline}
                color="textPrimary"
              >
                Public Finance, Game Theory, Industrial Economics, Time Series
                Modelling
              </Typography> */}
                {
                  "Public Finance, Game Theory, Industrial Economics, Time Series Modelling"
                }
              </React.Fragment>
            }
          />
        </ListItem>
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar className={classes.purpleAvatar}>M</Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Mathematics"
            secondary={
              <React.Fragment>
                {/* <Typography
                component="span"
                className={classes.inline}
                color="textPrimary"
              >
                to Scott, Alex, Jennifer
              </Typography> */}
                {
                  "Financial Mathematics with Computational Approach, Operations Research"
                }
              </React.Fragment>
            }
          />
        </ListItem>
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            {/* <Avatar alt="Remy Sharp" src="/static/images/avatar/3.jpg" /> */}
            <Avatar className={classes.green}>DS</Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Data Science"
            secondary={
              <React.Fragment>
                {/* <Typography
                component="span"
                className={classes.inline}
                color="textPrimary"
              >
                Sandra Adams
              </Typography> */}
                {
                  "Data Analytics Algorithms, Applied Data Analysis, Data Processing for Big Data, Modelling for Data Analysis, Data Wrangling, Data Visualisation, Distributed Databases and Big Data, Intelligent Systems (AI/ML)"
                }
              </React.Fragment>
            }
          />
        </ListItem>
      </List>
    </div>
  );
}

AlignItemsList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AlignItemsList);
